const USER_LOGOUT = '@@session/USER_LOGOUT';
const REQUEST_USER_LOGIN_STATUS = '@@session/REQUEST_USER_LOGIN_STATUS';
const USER_LOGIN_STATUS_RESPONSE = '@@session/USER_LOGIN_STATUS_RESPONSE';

export default {
    USER_LOGOUT,
    REQUEST_USER_LOGIN_STATUS,
    USER_LOGIN_STATUS_RESPONSE
};